import React from 'react'
import { Alert, InlineButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useNamesExperienceToggle } from '../../../../hooks/useNamesExperienceOptIn'

/**
 * Banner shown when the user is not opted into the updated Names experience, offering a control to
 * turn it on.
 *
 * @returns {JSX.Element}
 */
export default function NotOptedInBanner() {
  const [t] = useTranslation()
  const { turnOn, rolloutEnabled } = useNamesExperienceToggle()

  // With the master rollout flag off, the updated experience is unavailable, so hide the invite.
  if (!rolloutEnabled) return null

  return (
    <Alert outlined type="help" dense>
      {t(
        'namesExperienceBanner.notOptedIn.description',
        "We've updated the way you view, edit, and add names and details to a record."
      )}{' '}
      <InlineButton variant="link" onClick={turnOn} linkName="names-experience-banner-turn-on">
        {t('namesExperienceBanner.notOptedIn.turnOn', 'Turn on the updated look')}
      </InlineButton>
    </Alert>
  )
}
